import { render, staticRenderFns } from "./Emirler.vue?vue&type=template&id=44428a5a"
import script from "./Emirler.vue?vue&type=script&lang=ts"
export * from "./Emirler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports